<template>
  <sweet-modal
      :title="$t('project_dropdown_action_remove_BU_project')"
      blocking
      width="600px"
      ref="removeBUProject"
      class="modal"
      v-on:close="close">
    <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
      <el-form-item prop="businessUnitId" size="mini">
        <el-select v-model="form.businessUnitId" :placeholder="$t('modal_businessUnits')">
          <el-option
              v-for="bu in list"
              :key="bu.id"
              :label="bu.name"
              :value="bu.id"
              :disabled="bu.isLeader"
              @click.native="handleSelectBu(bu.id)"></el-option>
        </el-select>
      </el-form-item>
      <el-button size="medium" @click="remove('form')" type="primary">{{$t('general_remove')}}</el-button>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: "RemoveBUFromProjectModal",
  components: {
    SweetModal
  },
  data(){
    return {
      list: [],
      form: {
        businessUnitId: null
      },
      rules: {
        businessUnitId: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ]
      }
    }
  },
  methods:{
    async openModal(companyId, projectId){
      try {
        // const buList = await this.directories(companyId)

        // const selectedBUs = await this.item(companyId, projectId)

        // console.log('buList', buList, 'selectedBUs', selectedBUs)
        // if (buList.length && selectedBUs.length) {
        //   selectedBUs.map((val) => {
        //     this.list = this.list.concat(buList.filter(bal => bal.id === val))
        //   })
        // }

        this.list = await this.getBUList(companyId, projectId)

        this.$refs.removeBUProject.open()

        console.log(this.list)
      } catch (err) {
        console.log(err)
      }
    },
    directories(companyId){
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projects/directories?companyId=${companyId}&operation=update`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.businessUnitList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    item(companyId, projectId) {
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projects/item?companyId=${companyId}&projectId=${projectId}`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.item.businessUnitManagerArr)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    getBUList(companyId, projectId) {
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/projects/managers?projectId=${projectId}`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    handleSelectBu(id){
      console.log(id)
    },
    remove: function (form) {
      if (this.list.length < 2) {
        return this.notification(this.$t('general_warning'), this.$t('notification_cantRemoveLastBu'), "info")
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          const loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/projects/deleteBuForProject?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&buId=${this.form.businessUnitId}`)
              .then(response => {
                console.log(response)
                loader.hide()
                this.$refs.removeBUProject.close()
                this.$emit('loadList', parseInt(this.$route.query.projectId))
                this.notification(this.$t('general_success'), this.$t('notification_projectUpdated'), "success")
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    close(){
      this.$refs['form'].resetFields()
      this.list = []
      this.form.businessUnitId = null
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  }
}
</script>

<style scoped>

</style>
